var e = /* @__PURE__ */ ((r) => (r.Medium = "medium", r.Small = "small", r))(e || {}), c = /* @__PURE__ */ ((r) => (r.Primary = "primary", r.PrimaryDestructive = "primaryDestructive", r.Secondary = "secondary", r.SecondaryDestructive = "secondaryDestructive", r))(c || {});
export {
  e as SizesEnum,
  c as VariantsEnum
};
